import createVueApp from '@/common/createApp'
import { routerStyxie } from '@/router/styxieBridge'
import sidebar from '@/config/sidebars/organizationSettings'

// The organization-settings cluster is client-side routed: every action boots
// the shared router shell; the pages resolve their data through the API.
Styxie.Initializers.Organizations = routerStyxie({ actions: ['integrations']})
Styxie.Initializers.Users = routerStyxie({ actions: ['index', 'new', 'edit']})
Styxie.Initializers.Webhooks = routerStyxie({ actions: ['index']})
Styxie.Initializers.ApiTokens = routerStyxie({ actions: ['index']})
Styxie.Initializers.McpTokens = routerStyxie({ actions: ['index']})

Styxie.Initializers.WhiteLabelConfigurations = {
  ...routerStyxie({ actions: ['index', 'new', 'edit']}),
  // Unrouted ([side-effect-GET]): stays on full page loads with its styxie payload.
  test_gmb_api: async(props) => {
    const { default: Component } =
      await import('@/vue_widgets/organization_settings/white_label_configurations/test_gmb_api/index.vue')
    createVueApp(Component, { props, sidebar })
  }
}
